function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { selectContractListApi, enterprisePayTypeApi, clientBillSaveApi, billCateApi, clientBillEditApi, billFinanceApi, clientBillStatusApi } from '@/api/enterprise';
import { getToken } from '@/utils/auth';
import { uploader } from '@/utils/uploadCloud';
export default {
  name: 'ContractDialog',
  props: {
    config: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      dialogVisible: false,
      id: '',
      rules: {
        cid: '',
        num: undefined,
        date: '',
        mark: '',
        bill_cate_id: '',
        attach_ids: '',
        type_id: '',
        types: 2
      },
      val: '',
      imageUrl: '',
      uploadSize: 2,
      uploadData: {},
      myHeaders: {
        authorization: 'Bearer ' + getToken()
      },
      expireTimeOption: {
        disabledDate: function disabledDate(date) {
          return date.getTime() <= Date.now() - 8.64e7;
        }
      },
      rule: {
        cid: [{
          required: true,
          message: '请选择合同',
          trigger: 'change'
        }],
        num: [{
          required: true,
          message: '请输入支出金额',
          trigger: 'blur'
        }],
        date: [{
          required: true,
          message: '请选择时间',
          trigger: 'change'
        }],
        bill_cate_id: [{
          required: true,
          message: '请选择支出类型',
          trigger: 'change'
        }],
        type_id: {
          required: true,
          message: '请选择支付方式',
          trigger: 'change'
        } // 支付方式
      },
      labelWidth: 120,
      payText: '',
      sourceOptions: [],
      paymentOptions: [],
      billList: [],
      loading: false,
      contractData: []
    };
  },
  watch: {
    config: {
      handler: function handler(nVal) {
        if (nVal.data) {
          this.id = nVal.data.id;
          this.rules.cid = nVal.data.cid;
          this.rules.eid = nVal.data.eid;
          this.rules.num = nVal.data.num;
          this.rules.date = nVal.data.date;
          this.rules.type_id = nVal.data.type_id;
          this.rules.mark = nVal.data.mark;
          this.rules.bill_cate_id = nVal.data.bill_cate_id;
          if (nVal.data.attachs && nVal.data.attachs.length > 0) {
            this.rules.attach_ids = nVal.data.attachs[0].id;
            this.imageUrl = nVal.data.attachs[0].src;
          }
        }
      }
    }
  },
  methods: {
    // 上传文件方法
    uploadServerLog: function uploadServerLog(params) {
      var _this = this;
      var file = params.file;
      var options = {
        way: 2,
        relation_type: 'bill',
        relation_id: '',
        eid: ''
      };
      uploader(file, 1, 2, options).then(function (res) {
        // 获取上传文件渲染页面
        if (res.name) {
          _this.imageUrl = res.url;
          _this.rules.attach_ids = res.attach_id;
        }
      }).catch(function (err) {});
    },
    // 获取当前时间
    getTime: function getTime() {
      this.rules.date = this.$moment().format('YYYY-MM-DD HH:mm:ss');
    },
    // 获取支出分类
    getBillCate: function getBillCate() {
      var _this2 = this;
      var data = {
        types: 0
      };
      billCateApi(data).then(function (res) {
        _this2.billList = res.data;
      });
    },
    getTableData: function getTableData() {
      var _this3 = this;
      selectContractListApi({
        data: [this.config.eid]
      }).then(function (res) {
        _this3.contractData = res.data;
        if (_this3.contractData.length > 0) {
          _this3.rules.cid = _this3.contractData[0].id;
        }
      });
    },
    handleConfirm: function handleConfirm() {
      var _this4 = this;
      if (!this.config.data) {
        if (this.config.formType !== 'list') {
          this.rules.cid = this.config.cid;
        }
        this.rules.eid = this.config.eid;
      }
      this.$refs.form.validate(function (valid) {
        if (valid) {
          if (_this4.config.source == 'fd') {
            if (_this4.config.type == 'edit') {
              _this4.billFinance();
            } else {
              _this4.passFn();
            }
          } else {
            if (_this4.config.edit) {
              _this4.editFn();
            } else {
              _this4.saveFn();
            }
          }
        }
      });
    },
    passFn: function passFn() {
      var _this5 = this;
      this.loading = true;
      this.rules.status = 1;
      clientBillStatusApi(this.id, this.rules).then(function (res) {
        _this5.loading = false;
        _this5.$emit('isOk');
        _this5.dialogVisible = false;
        _this5.reset();
      }).catch(function (err) {
        _this5.loading = false;
      });
    },
    editFn: function editFn() {
      var _this6 = this;
      this.loading = true;
      clientBillEditApi(this.id, this.rules).then(function (res) {
        _this6.loading = false;
        _this6.dialogVisible = false;
        _this6.$emit('isOk');
        _this6.reset();
      }).catch(function (err) {
        _this6.loading = false;
      });
    },
    // 财务编辑
    billFinance: function billFinance() {
      var _this7 = this;
      this.loading = true;
      billFinanceApi(this.id, this.rules).then(function (res) {
        _this7.loading = false;
        _this7.$emit('isOk');
        _this7.dialogVisible = false;
        _this7.reset();
      }).catch(function (err) {
        _this7.loading = false;
      });
    },
    saveFn: function saveFn() {
      var _this8 = this;
      this.loading = true;
      clientBillSaveApi(this.rules).then(function (res) {
        _this8.loading = false;
        _this8.dialogVisible = false;
        _this8.$emit('isOk');
        _this8.reset();
      }).catch(function (err) {
        _this8.loading = false;
      });
    },
    handleOpen: function handleOpen() {
      var _this9 = this;
      this.dialogVisible = true;
      this.getTime();
      this.getPaymentMethod();
      if (this.config.source !== 'fd') {
        setTimeout(function () {
          _this9.getTableData();
        }, 200);
      }
      this.getBillCate();
    },
    handleClose: function handleClose() {
      this.dialogVisible = false;
      this.imageUrl = '';
      this.rules.endDate = '';
      this.rules.type = '', this.$refs.form.resetFields();
      if (this.config.edit === 2) {
        this.reset();
      }
      this.reset();
    },
    reset: function reset() {
      this.imageUrl = '';
      this.rules = {
        cid: '',
        num: undefined,
        date: '',
        mark: '',
        bill_cate_id: '',
        attach_ids: '',
        type_id: '',
        bill_types: 0,
        types: 2
      };
    },
    // 获取支付方式
    getPaymentMethod: function getPaymentMethod() {
      var _this10 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var data, result;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              data = {
                status: 1
              };
              _context.next = 3;
              return enterprisePayTypeApi(data);
            case 3:
              result = _context.sent;
              _this10.paymentOptions = result.data.list;
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  }
};